import React from 'react';

const Reset: React.FC = () => {

  const meta = document.createElement('meta');
  meta.httpEquiv = "refresh";
  meta.content = "0;#/impersonate";
  document.getElementsByTagName('head')[0].appendChild(meta);
  return null;
}

export default Reset;